import APIDOC from '@/common/serverApi';
import {ApiEncryption} from "@/common/validate";
import fa from "element-ui/src/locale/lang/fa";
import {get, post} from '@/common/request';
import store from '@/store';

// 格式化时间
export function timeFormat(date, format) {
    if (date == null || date === '') {
        return "";
    }

    // 填充
    function fillString(num) {
        if (num < 10) {
            return `0${num}`;
        } else {
            return num;
        }
    }

    let result = '';
    // yyyy:MM:dd HH:mm:ss ww
    const dateString = new Date(date);
    const year = dateString.getFullYear();
    const mouth = dateString.getMonth() + 1;
    const day = dateString.getDate();
    const Hour = dateString.getHours();
    const minute = dateString.getMinutes();
    const second = dateString.getSeconds();
    if (format) {
        result = format.replace(/yyyy/, year)
            .replace(/MM/, fillString(mouth))
            .replace(/dd/, fillString(day))
            .replace(/HH/, fillString(Hour))
            .replace(/mm/, fillString(minute))
            .replace(/ss/, fillString(second));
    } else {
        result = `${year}年${mouth}月${day}日`;
    }
    return result;
}

// 格式化时间 2020-00-00 00:00:00 至 2020-00-00 00:00:00
export function timeFormatTo(date) {
    if (date == null || date === '') {
        return "";
    } else {
        let dateArray = date.split(" 至 ");
        return dateArray[0].substring(0, 16) + " 至 " + dateArray[1].substring(0, 16);
        ;
    }
}

// 判断是否是一个完整的地址
export function isUrl(value) {
    const urlReg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
    if (!value) {
        return false;
    }
    const result = value.match(urlReg);
    if (result) {
        return true;
    } else {
        return false;
    }
}

// 替换字符串中的图片地址
export function imgHtml(content) {
    let this_ = this;
    content = content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, capture) {
        let c = capture; //地址
        let m = match; //img标签
        if (this_.$isUrl(c)) {
            return m;
        } else {
            let l = c.indexOf("/filesystem/");
            return m.replace(c, this_.$baseUrl + c.substring(l, c.length));
        }
    });
    return content;
}

// 图片正则
export function getRealUrl(value) {
    if (value == null || value === '') {
        return value;
    } else {
        if (value.indexOf('http') >= 0) {
            return value;
        } else {
            return APIDOC.BASEURL + value;
        }
    }

    // const result = isUrl(value);
    // if (result) {
    //   return value;
    // } else {
    //   return APIDOC.BASEURL + value;
    // }
}

// 过滤价格
export function priceValue(value) {
    if (!value) {
        return '';
    }
    const result = value.split('￥');
    if (result[1]) {
        return (result[1]).trim().replace('.00', ''); // 去掉价格.00
    } else {
        return '';
    }
}

//数据小于9时 前面加0
export function zero(value) {
    if (value <= 9) {
        return "0" + value;
    } else {
        return value;
    }
}

// url参数获取
export function getQueryVariable(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return (false);
}

// 学籍状态(1在籍 1_2转专业 1_3转函授站 1_4转班级 1_5复学 1_6留级 2休学 3未报到 4主动退学 5勒令退学 6取消学籍 7已毕业)
export function studentState(v) {
    return v == "1" ? "在籍" :
        v == "1_2" ? "转专业" :
            v == "1_3" ? "转函授站" :
                v == "1_4" ? "转班级" :
                    v == "1_5" ? "复学" :
                        v == "1_6" ? "留级" :
                            v == "2" ? "休学" :
                                v == "3" ? "未报到" :
                                    v == "4" ? "主动退学" :
                                        v == "5" ? "勒令退学" :
                                            v == "6" ? "取消学籍" :
                                                v == "7" ? "已毕业" : "-";
}

// 消息类型（1通知 2公开资料 3留言 4学生消息 5教师消息 6用户消息 7私密资料）
export function messageType(v) {
    return v == "1" ? "通知" :
        v == "2" ? "公开资料" :
            v == "3" ? "留言" :
                v == "4" ? "学生消息" :
                    v == "5" ? "教师消息" :
                        v == "6" ? "用户消息" :
                            v == "7" ? "私密资料" :
                                "-";
}

// 考核方式(1考试 2考察 3统考 4实践)'
export function examCheckType(v) {
    return v == "1" ? "考试" :
        v == "2" ? "考察" :
            v == "3" ? "统考" :
                v == "4" ? "实践" : "-";
}

// 验证码定时器
export function doTimer(second, cb) {
    let timer = null;
    return function doLoop() {
        timer = setTimeout(() => {
            if (second < 1) {
                clearTimeout(timer);
            } else {
                second--;
                cb(second);
                doLoop();
            }
        }, 1000);
    };
}

// 延迟定时器
export const createTimer = (function () {
    let timer = null;
    return {
        getTimer: function doLoop(fn, delay) {
            const time = delay * 1000;
            timer = setTimeout(() => {
                fn(true);
                doLoop.apply(this, arguments);
            }, time);
        },
        cancelTimer: function () {
            clearTimeout(timer);
        }
    };
}());

// 付款
export function weixinPay(data) {
    return new Promise((resolve, reject) => {
        //  调用API
        const onBridgeReady = function () {
            /* eslint-disable */
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                    appId: data.appId, // 公众号名称，由商户传入
                    timeStamp: data.timeStamp, // 时间戳，自1970年以来的秒数
                    nonceStr: data.nonceStr, // 随机串
                    package: data.packageValue,
                    signType: data.signType, // 微信签名方式：
                    paySign: data.paySign, // 微信签名
                },
                (res) => {
                    if (res.err_msg === 'get_brand_wcpay_request:ok') {
                        resolve('ok')
                    } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                        reject('cancel');
                    } else {
                        reject(res);
                    }
                },
            );
        }
        /* eslint-disable */
        if (typeof WeixinJSBridge === 'undefined') {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', () => {
                    onBridgeReady();
                }, false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', () => {
                    onBridgeReady();
                });
                document.attachEvent('onWeixinJSBridgeReady', () => {
                    onBridgeReady();
                });
            }
        } else {
            onBridgeReady();
        }
    });
}

// 判断手机类型
export const deviceType = (function () {
    const ua = window.navigator.userAgent.toLocaleLowerCase();
    const isIos = /iphone|ipad|ipod/.test(ua);
    const isAndroid = /android/.test(ua);
    return {
        isIos: isIos,
        isAndroid: isAndroid
    }
}());

// 监听键盘弹起和收起事件方法封装
export function watchKeyword(el, current) {
    // 如果是Ios设备，就监听获得焦点和失去焦点，运用dom2级事件true捕获阶段处理，fasle冒泡阶段处理
    if (deviceType.isIos) {
        // Ios 输入框获得焦点，软键盘弹起
        el.addEventListener('focus', function () {
            // 键盘弹起
            current.showfixed = false;
        }, false);

        // Ios 输入框失去焦点键盘收起
        el.addEventListener('blur', function () {
            // 键盘收起
            current.showfixed = true;
            // 修复微信浏览器版本6.7.4 IOS12会出现键盘收起后，视图被顶上去了没有下来
            var wechatInfo = window.navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
            if (!wechatInfo) return;
            var wechatVersion = wechatInfo[1];
            var version = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            if (+wechatVersion.replace(/\./g, '') >= 674 && +version[1] >= 12) {
                setTimeout(function () {
                    window.scrollTo(0, Math.max(document.body.clientHeight, document.documentElement.clientHeight));
                })
            }
        }, false)
    }
    // 如果是Android设备，就监听页面尺寸变化，运用dom2级事件true捕获阶段处理，fasle冒泡阶段处理
    if (deviceType.isAndroid) {
        // 原始高度
        var originHeight = document.documentElement.clientHeight || document.body.clientHeight;
        window.addEventListener('resize', function () {
            // 新高度
            var newHeight = document.documentElement.clientHeight || document.body.clientHeight;
            if (newHeight > originHeight) {
                // 键盘收起
                current.showfixed = true;
            } else {
                // 键盘弹起
                current.showfixed = false;
                // 修复安卓设备软键盘弹起会覆盖掉输入框
                elScrollIntoView(el, 100)
            }
            originHeight = newHeight
        }, false)
    }
}


// 获取到焦点元素滚动到可视区方法
export function elScrollIntoView(el, delay) {
    // contentEditable 属性设置或返回元素内容是否可编辑。
    var editable = el.getAttribute('contenteditable')
    // 输入框获取焦点后没有将该元素滚动到可视区
    if (el.tagName == 'INPUT' || el.tagName == 'TEXTAREA' || editable === '' || editable) {
        setTimeout(function () {
            // 让当前的元素滚动到浏览器窗口的可视区域内。
            el.scrollIntoView();
        }, delay)
    }
}

export function getUserInfoAll(keyId) {
    store.dispatch('user/getUserCenter')
        .then((ret) => {
            if (ret.code === 0) {
                // 保存登录信息到vuex
                store.commit('USERINFO', ret.data);
                // 保存登录信息到到session 和 local
            } else {
                this.$router.push({name: 'ServerError', params: {keyId: keyId}});
            }
        })
        .catch(() => {

        });
}

export function noFind(event) {
    var img = event;
    img.src = "https://pic.cnblogs.com/avatar/1505226/20191123150748.png" // 默认图片地址
    img.onerror = null; // 控制不要循环展示错误
}

/**
 * 判断是否是微信浏览器
 */
export function isWeixin() {
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf('micromessenger') != -1;
    if (isWeixin) {
        return true;
    } else {
        return false;
    }
}

/**
 * 判断数值类型的比较  原因：为了解决   1==1 || 1===1 的问题
 */
export function NumEqual(num_0, num_1) {
    if (num_0 === num_1 || num_0 == num_1) {
        return true;
    } else {
        return false;
    }
}

/**
 * @param {非空验证} value
 */
export function isEmpty(value) {
    if (value == "" || value == undefined || value == "undefined" | value == "[]" || value == null || value == 'null') {
        return true;
    }
    return false;
}


//通知后台获取到了token
export function getTokenSuccess(key_id) {
    store.dispatch('getTokenSuccess', {key_id: key_id});
}

//关闭页面
export function closePage() {
    window.location.href = "about:blank";
    window.close();
}

/**
 * @param {*} currentTime 当前时间
 * @param {*} endTime 结束时间
 * @param {*} showName 显示位置（变量名）
 */
export function timeInterval(currentTime, endTime, showName) {
    let _this = this;
    let second = (Date.parse(new Date(endTime)) - Date.parse(currentTime)) / 1000 //(考试结束时间 -  当前时间) / 1000 = 相差秒数
    let setInt = setInterval(function () {
        second = Number(second) - 1;
        if (second <= 0) {
            _this[showName] = "0 秒";
            clearInterval(setInt);
        } else {
            let min = Math.floor(second / 60 % 60), //分
                sec = Math.floor(second % 60); //秒
            if (min <= 9) {
                min = "0" + min;
            }
            if (sec <= 9) {
                sec = "0" + sec;
            }
            _this[showName] = min + " 分钟 " + sec + " 秒";
        }
    }, 1000);
}

/**
 * 毫秒转分钟
 */
export function returnMin(time, n) {
    if (time == null || time == "") {
        return 0;
    } else {
        let mm = Math.floor(time / (60 * 1000)); //分钟
        let ss = Math.floor(time / 1000); //秒
        if (n == null || n == "") {
            return mm;
        }
        if (mm <= 0) {
            return ss + (n != null && n != "" ? " 秒钟" : "")
        } else {
            return mm + (n != null && n != "" ? " 分钟" : "")
        }
    }
}

/**
 * 毫秒转分钟秒
 */
export function returnMinSecond(list) {
    if (list.length <= 0) {
        return "00:00:00";
    } else {

        if (list[list.length - 1].courseVideoTime == list[list.length - 1].tsTime) {
            return '已完成';
        } else {
            let totalTime = "";
            let tsTime = "";
            let mss = list[list.length - 1].courseVideoTime;
            let mssTs = list[list.length - 1].tsTime;
            let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) < 10 ? '0' + parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) : parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60)) < 10 ? '0' + parseInt((mss % (1000 * 60 * 60)) / (1000 * 60)) : parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((mss % (1000 * 60)) / 1000 < 10 ? '0' + (mss % (1000 * 60) / 1000) : (mss % (1000 * 60)) / 1000);
            totalTime = hours + ":" + minutes + ":" + (seconds <= 9 ? '0' + seconds : seconds);

            let hoursTs = parseInt((mssTs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) < 10 ? '0' + parseInt((mssTs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) : parseInt((mssTs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutesTs = parseInt((mssTs % (1000 * 60 * 60)) / (1000 * 60)) < 10 ? '0' + parseInt((mssTs % (1000 * 60 * 60)) / (1000 * 60)) : parseInt((mssTs % (1000 * 60 * 60)) / (1000 * 60));
            let secondsTs = Math.floor((mssTs % (1000 * 60)) / 1000 < 10 ? '0' + (mssTs % (1000 * 60) / 1000) : (mssTs % (1000 * 60)) / 1000);
            tsTime = hoursTs + ":" + minutesTs + ":" + (secondsTs <= 9 ? '0' + secondsTs : secondsTs);

            return tsTime + "/" + totalTime;
        }
    }
}

/**
 * 判断视频是否观看完成
 */
export function lookVideo(list) {
    if (list.length <= 0) {
        return false;
    } else {
        if (Number(list[list.length - 1].courseVideoTime) <= Number(Number(list[list.length - 1].tsTime) + 5000)) {
            return true;
        } else {
            return false;
        }
    }
}

/**
 * 判断是否有http请求头
 */
export function isHttp(url) {
    if (url != null && url != "") {
        url = url.replace(/\\/g, "/");
    }
    if (url.substring(0, 4).indexOf("http") >= 0 || url.substring(0, 4).indexOf("HTTP") >= 0 || url.indexOf("base64,") >= 0) {
        return url;
    } else {
        return APIDOC.BASEURL + url;
    }
}

/**
 * 阿拉伯数字转换成中文数字
 */
export function chineseNum(index) {
    let info = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二", "十三", "十四", "十五"];
    return info[index];
}

/**
 * 关闭当前页面
 */
export function closeWin() {
    window.location.href = "about:blank";
    window.close();
}


/**
 * @param {比较两个时间的大小} start send
 */
export function compareTime(start, send) {
    if (start == null) {
        return true;
    } else if (send == null) {
        return false;
    }
    return (new Date(start.replace(/-/g, "/"))) < (new Date(send.replace(/-/g, "/")));
}

/**
 * 获取当前时间的年月日
 * @param {Object}
 */
export function getNewDate() {
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth() + 1;
    let dd = new Date().getDate();
    let hh = new Date().getHours();
    let mf = new Date().getMinutes();
    let ss = new Date().getSeconds();
    return yy + '-' + this.$zero(mm) + '-' + this.$zero(dd) + ' ' + this.$zero(hh) + ':' + this.$zero(mf) + ':' + this.$zero(ss);
}

/**
 * 获取包含某个字符的所有缓存
 * @param {Object}
 */
export function getBylocal(name) {
    const dataInfo = localStorage.valueOf();
    let arrayList = new Array();
    let keyList = new Array();
    for (let key in dataInfo) {
        if (key.indexOf(name) >= 0) {
            arrayList.push(JSON.parse(dataInfo[key]));
            keyList.push(key); //用于上传成功后删除相应的缓存  避免出现删除未上传的信息
        }
    }
    return {
        arrayList: arrayList,
        keyList: keyList
    };
    // return JSON.parse(localStorage.getItem(name));
}

/**
 * 删除list中的缓存
 * @param {Object}
 */
export function delBylocal(name) {
    // const dataInfo = localStorage.valueOf();
    // for(let key in dataInfo){
    //   if(key.indexOf(name) >= 0){
    //     localStorage.removeItem(key);
    //   }
    // }
    for (let i = 0; i < name.length; i++) {
        localStorage.removeItem(name[i]);
    }
}

/**
 * 删除包含某个字符的所有缓存
 * @param {Object}
 */
export function delAllBylocal(name) {
    const dataInfo = localStorage.valueOf();
    for(let key in dataInfo){
      if(key.indexOf(name) >= 0){
        localStorage.removeItem(key);
      }
    }
}

/**
 * @param {上传视频记录信息}
 */
export function uploadCourselog() {
    let videoLoading = sessionStorage.getItem(getStorageKeyForRoleTag("videoLoading"));
    if (this.$isEmpty(videoLoading)) {
        sessionStorage.setItem(getStorageKeyForRoleTag("videoLoading"), 1);
        let logInfoMap = this.$getBylocal(getStorageKeyForRoleTag("courselog_")); //获取所有视频记录List
        let logInfo = logInfoMap.arrayList;
        if (!this.$isEmpty(logInfo) && logInfo.length > 0) { //存在数据则执行上传
            // console.log("上传视频播放记录信息中...");
            store.dispatch("user/saveVideosLog", {data: JSON.stringify(logInfo)}).then((res) => {
                // console.log("上传视频播放记录信息成功...");
                sessionStorage.removeItem(getStorageKeyForRoleTag("videoLoading"));
                if (res.code == 0) {
                    this.$delBylocal(logInfoMap.keyList); //上传成功 删除所有视频播放的缓存
                } else {
                    console.log("上传视频播放记录信息失败..." + res.msg);
                }
            }).catch((error) => {
                sessionStorage.removeItem(getStorageKeyForRoleTag("videoLoading"));
                console.log("上传视频播放记录信息失败..." + error);
            });
        } else {
            sessionStorage.removeItem(getStorageKeyForRoleTag("videoLoading"));
        }
    } else {
        sessionStorage.removeItem(getStorageKeyForRoleTag("videoLoading"));
    }
}

export function openWithRoleTag(url) {
    const queryVariable = getQueryVariable("_role_tag");
    const p = url.indexOf("?") >= 0 ? "&" : "?";
    if (url.slice(-1) === "\\" || url.slice(-1) === "/") {
        url = url.substring(0, url.length - 1);
    }
    if (queryVariable) {
        window.open(url + p + "_role_tag=" + queryVariable);
    } else {
        window.open(url);
    }
}

export function getCookieForRoleTag() {
    const cookieKeys = self.$cookies.keys();
    for (const cookieKey of cookieKeys) {
        let value = self.$cookies.get(cookieKey);
        if (!isEmpty(value)) {
            let time = value.split(".")[value.split(".").length - 1];
            if (getQueryVariable("_role_tag") == time) {
                return value;
            }
        }

    }
    return null;
}

export function getCookieKeyForRoleTag() {
    const cookieKeys = self.$cookies.keys();
    for (const cookieKey of cookieKeys) {
        let value = self.$cookies.get(cookieKey);
        if (!isEmpty(value)) {
            let time = value.split(".")[value.split(".").length - 1];
            if (getQueryVariable("_role_tag") == time) {
                return cookieKey;
            }
        }

    }

    return null;
}

export function getStudentInfoKeyForRoleTag() {
    return "studentInfo" + getCookieKeyForRoleTag();
}

export function getStorageKeyForRoleTag(key) {
    if (key) {
        if (key.substr(-1) === "_") {
            return key + getCookieKeyForRoleTag();
        } else {
            return key + "_" + getCookieKeyForRoleTag();
        }
    }

    return null;
}

/**
 *   判断字符串数组中任意一个是否在hostname中存在
 * @param strArr  要在hostname里面查找的字符串数组
 * @returns {boolean}
 * @author zhouzhao
 */
//'lfjtysxx'
export function strExistHostnameOnce(strArr) {
    const hostname = window.location.hostname;
    if (!strArr) {
        return false;
    }
    for (let strArrKey of strArr) {
        if (hostname.indexOf(strArrKey) > -1) {
            return true;
        }
    }
    return false;
}

/**
 * 同步课程信息
 * tag ：1，直接同步 2：查看视频页面手动同步
 * isClear = 'clear':执行清理缓存
 */
export function getClientNeedStudyLog(tag,isClear,triggerSource) {
    if (!this.$isEmpty(getCookieForRoleTag())) {
        let syncTime = localStorage.getItem(getStorageKeyForRoleTag("syncTime")); //获取上一次执行同步课程数据的时间戳
        if (tag == 1 || tag == 2 || this.$isEmpty(syncTime) || new Date().getTime() >= Number(syncTime) + (30 * 1000)) { //上一次与现在的时间戳对比，如果小于一小时则不执行同步方法
            // const ret = {
            // 		"code": 0,
            // 		"msg": "成功",
            // 		"data": {
            // 			"5946": {
            // 				"0": {
            // 					"tePlanCourseId": "1575369539087540224",
            // 					"tePlanCourseName": "第一章第1、2节",
            // 					"type": "OK"
            // 				},
            // 				"1": {
            // 					"tePlanCourseId": "1575369539095928832",
            // 					"tePlanCourseName": "第一章第3节",
            // 					"type": "OK"
            // 				},
            // 				"2": {
            // 					"tePlanCourseId": "1575369539104317440",
            // 					"tePlanCourseName": "第一章第4、5节",
            // 					"type": "OK"
            // 				},
            // 				"3": {
            // 					"tePlanCourseId": "1575369539112706048",
            // 					"tePlanCourseName": "第二章第1节",
            // 					"type": "OK"
            // 				},
            // 			},
            // 		}
            // }
            //localStorage.setItem(getStorageKeyForRoleTag("courseInfoLog_")+"5956", JSON.stringify({0:"OK",1:"OK",2:"OK",3:"OK"}));
            console.log("执行了对比课程任务");
            let loadingInfo = null;
            if (tag == 2) {
                loadingInfo = this.$loading({
                    lock: true,
                    text: '同步中，请稍等...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            }
            localStorage.setItem(getStorageKeyForRoleTag("syncTime"), new Date().getTime()); //存入本次执行同步的时间，一小时内无法再执行同步方法
            store.dispatch("user/getClientNeedStudyLog", {_role_tag: getQueryVariable("_role_tag"),triggerSource:triggerSource || ""}).then((res) => {
                // res = ret;
                if (res.code == 0) {
                    if (this.$isEmpty(res.data)) {
                        if (tag == 2) {
                            this.$message.success(isClear == 'clear'?"清理成功":"同步成功");
                            if(isClear == 'clear'){ //清理课程播放缓存
                                this.$delAllBylocal(getStorageKeyForRoleTag("courseInfoLog_")); //同步成功 删除所有视频播放的缓存
                                this.$delAllBylocal(getStorageKeyForRoleTag("courselog_")); //同步成功 删除所有视频播放的缓存
                                this.$delAllBylocal(getStorageKeyForRoleTag("courseTimeMap_")); //同步成功 删除
                                setTimeout(()=>{
                                    this.$router.go(0);
                                },1000);
                            }
                            loadingInfo.close();
                        }
                        console.log("没有课程，退出");
                        return;
                    }
                    const dataInfo = localStorage.valueOf(); //获取所有缓存 courseInfoLog_课程ID
                    let courseIdMap = {}; //课程MAP信息{课程ID：{0:"OK",1:"OK"}}
                    for (let key in dataInfo) { //根据所有缓存，获取本地课程查看记录
                        if (key.indexOf(getStorageKeyForRoleTag("courseInfoLog_")) >= 0) {
                            let array = key.split(getCookieKeyForRoleTag());
                            courseIdMap[array[1]] = JSON.parse(localStorage.getItem(key))
                        }
                    }
                    if (Object.keys(courseIdMap).length > 0) { //本地存在课程看完记录则执行对比
                        let TPCIds = ""; //存在差异的数据
                        for (let item in courseIdMap) {
                            for (let it in courseIdMap[item]) {
                                let info = it;
                                if (it.indexOf("_") >= 0) {
                                    info = it.split("_")[1];
                                }
                                if (!this.$isEmpty(res.data[item]) && !this.$isEmpty(res.data[item][info]) && res.data[item][info].type != courseIdMap[item][it]) {
                                    TPCIds += res.data[item][info].tePlanCourseId + ",";
                                }
                            }
                        }
                        if (!this.$isEmpty(TPCIds)) { //提交只提交本地完成后端没完成的
                            console.log("存在差异");
                            store.dispatch("user/compensateVideoLog", {TPCIds: TPCIds}).then((res) => {
                                if (tag == 2) {
                                    if (res.code == 0) {
                                        this.$message.success(isClear == 'clear'?"清理成功":"同步成功");
                                        if(isClear == 'clear'){ //清理课程播放缓存
                                            this.$delAllBylocal(getStorageKeyForRoleTag("courseInfoLog_")); //同步成功 删除所有视频播放的缓存
                                            this.$delAllBylocal(getStorageKeyForRoleTag("courselog_")); //同步成功 删除所有视频播放的缓存
                                            this.$delAllBylocal(getStorageKeyForRoleTag("courseTimeMap_")); //同步成功 删除

                                            setTimeout(()=>{
                                                this.$router.go(0);
                                            },1000);
                                        }
                                    } else {
                                        this.$message.error(res.msg);
                                    }
                                    loadingInfo.close();
                                }
                                if (res.code == 0) {
                                    console.log("执行同步成功！");
                                } else {
                                    localStorage.setItem(getStorageKeyForRoleTag("syncTime"), syncTime); //存入本次执行同步的时间，一小时内无法再执行同步方法
                                    console.log("执行同步失败！" + res.msg);
                                }
                            }).catch(function (error) {
                                if (tag == 2) {
                                    this.$message.error("同步失败，请稍后重试！");
                                    loadingInfo.close();
                                }
                            });
                        } else {
                            if (tag == 2) {
                                this.$message.success(isClear == 'clear'?"清理成功":"同步成功");
                                if(isClear == 'clear'){ //清理课程播放缓存
                                    this.$delAllBylocal(getStorageKeyForRoleTag("courseInfoLog_")); //同步成功 删除所有视频播放的缓存
                                    this.$delAllBylocal(getStorageKeyForRoleTag("courselog_")); //同步成功 删除所有视频播放的缓存
                                    this.$delAllBylocal(getStorageKeyForRoleTag("courseTimeMap_")); //同步成功 删除
                                    setTimeout(()=>{
                                        this.$router.go(0);
                                    },1000);
                                }
                                loadingInfo.close();

                            }
                            console.log("不存在差异");
                        }
                    } else {
                        if (tag == 2) {
                            this.$message.success(isClear == 'clear'?"清理成功":"同步成功");
                            if(isClear == 'clear'){ //清理课程播放缓存
                                this.$delAllBylocal(getStorageKeyForRoleTag("courseInfoLog_")); //同步成功 删除所有视频播放的缓存
                                this.$delAllBylocal(getStorageKeyForRoleTag("courselog_")); //同步成功 删除所有视频播放的缓存
                                this.$delAllBylocal(getStorageKeyForRoleTag("courseTimeMap_")); //同步成功 删除
                                setTimeout(()=>{
                                    this.$router.go(0);
                                },1000);
                            }
                            loadingInfo.close();

                        }
                        console.log("本地没有缓存！");
                    }
                } else {
                    if (tag == 2) {
                        this.$message.error(res.msg);
                        loadingInfo.close();
                    }
                    //失败不需要重新调用了,如果需要打开下面注释
                    //localStorage.setItem(getStorageKeyForRoleTag("syncTime"),syncTime); //存入本次执行同步的时间，一小时内无法再执行同步方法
                }
            }).catch(function (error) {
                if (tag == 2) {
                    this.$message.error("同步失败，请稍后重试！");
                    loadingInfo.close();
                }
                //失败不需要重新调用了,如果需要打开下面注释
                console.log(error, "调用课程对比方法失败了")
                //localStorage.setItem(getStorageKeyForRoleTag("syncTime"),syncTime); //存入本次执行同步的时间，一小时内无法再执行同步方法
            });
        } else {
            console.log("等待中...")
        }
    } else {
        console.log("未登录...")
    }

}

/**
 * 下载文件
 * @param {Object} url //文件地址
 * @param {Object} name //文件名称，为空时取文件名称
 */
export function downLoadFile(url, name) {
    if (this.$isEmpty(url)) {
        this.$message.warning("暂无文件！");
        return;
    } else {
        url = this.$isHttp(url);
    }
    let token = this.$getCookieForRoleTag();
    let this_ = this;
    const loading = this.$loading({ //开启加载
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    if (this.$isEmpty(name)) {
        var first = url.lastIndexOf("."); //取到文件名开始到最后一个点的长度
        var nameL = url.lastIndexOf("/");
        var namelength = url.length; //取到文件名长度
        var filesuffix = url.substring(first + 1, namelength); //截取获得后缀名
        name = (url.substring(nameL + 1, first) || '附件') + "." + filesuffix
    }
    // 下载文件
    download(url, name); // OSS可下载的文件url，你想要改的名字
    function getBlob(url, cb) {
        // 获取文件流
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.setRequestHeader('token', token);
        xhr.responseType = "blob";
        xhr.onload = function () {
            if (xhr.status === 200) {
                cb(xhr.response);
            } else {
                loading.close(); //关闭加载
                this_.$message.warning("获取文件失败！");
            }
        };
        xhr.send();
    }

    function saveAs(blob, filename) {
        // 改名字
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            var body = document.querySelector("body");

            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            loading.close(); //关闭加载

            // fix Firefox
            link.style.display = "none";
            body.appendChild(link);

            link.click();
            body.removeChild(link);

            window.URL.revokeObjectURL(link.href);
        }
    }

    function download(url, filename) {
        // 执行
        getBlob(url, function (blob) {
            saveAs(blob, filename);
        });
    }
}


/** 获取用户IP */
export function getUserIP(onNewIP) {
    let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
    let pc = new MyPeerConnection({
        iceServers: []
    });
    let noop = () => {
    };
    let localIPs = {};
    let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
    let iterateIP = (ip) => {
        if (!localIPs[ip]) onNewIP(ip);
        localIPs[ip] = true;
    };
    pc.createDataChannel('');
    pc.createOffer().then((sdp) => {
        sdp.sdp.split('\n').forEach(function (line) {
            if (line.indexOf('candidate') < 0) return;
            line.match(ipRegex).forEach(iterateIP);
        });
        pc.setLocalDescription(sdp, noop, noop);
    }).catch((reason) => {
    });
    pc.onicecandidate = (ice) => {
        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
    };
}

export function base64ToFile(base64, fileName) {
    let arr = base64.split(",");
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, {type: 'image/jpg'});
}

/**
 * 点击章节学习时调用
 */
export function getMessageAccept(tePlanCourseId){
    if(this.$isEmpty(tePlanCourseId)){
        return;
    }
    let url = "/api/student/"+ApiEncryption() + "/getMessageAccept.do";
    get(window.configs.API_ROOT + url,{tePlanCourseId:tePlanCourseId}).then((ret) => {

    });
}

/**
 * 用于其他接口调用后，调用
 */
export function APInterface(triggerSource){
    let newTime = localStorage.getItem(getStorageKeyForRoleTag("new_index_time")); //获取上一次执行获取方法的时间
    // let newTag = localStorage.getItem(getStorageKeyForRoleTag("new_index_tag")); //表是已有页面展示
    if(this.$isEmpty(newTime) || new Date().getTime() >= Number(newTime) + (30 * 1000)){ //距离上次获取信息相差一分钟了可以继续调用
        localStorage.setItem(getStorageKeyForRoleTag("new_index_time"),new Date().getTime());
        let url = "/api/student/"+ApiEncryption() + "/getMessageAccept.do";
        get(window.configs.API_ROOT + url,{triggerSource:triggerSource}).then((ret) => {
            if(ret.code == 0 && !this.$isEmpty(ret.data.messageAcceptId)){
                localStorage.setItem(getStorageKeyForRoleTag("new_Info"),JSON.stringify(ret.data));
            }
        });
    }
}

/*
 * @param: fileName - 文件名称
 * @param: 数据返回 1) 无后缀匹配 - false
 * @param: 数据返回 2) 匹配图片 - image
 * @param: 数据返回 3) 匹配 txt - txt
 * @param: 数据返回 4) 匹配 excel - excel
 * @param: 数据返回 5) 匹配 word - word
 * @param: 数据返回 6) 匹配 pdf - pdf
 * @param: 数据返回 7) 匹配 ppt - ppt
 * @param: 数据返回 8) 匹配 视频 - video
 * @param: 数据返回 9) 匹配 音频 - radio
 * @param: 数据返回 10) 其他匹配项 - other
 */
export function matchType(fileName) {
  // 后缀获取
  var suffix = '';
  // 获取类型结果
  var result = '';
  try {
    var flieArr = fileName.split('.');
    suffix = flieArr[flieArr.length - 1];
  } catch (err) {
    suffix = '';
  }
  // fileName无后缀返回 false
  if (!suffix) {
    result = false;
    return result;
  }
  // 图片格式
  var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
  // 进行图片匹配
  result = imglist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'image';
    return result;
  };
  // 匹配txt
  var txtlist = ['txt'];
  result = txtlist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'txt';
    return result;
  };
  // 匹配 excel
  var excelist = ['xls', 'xlsx'];
  result = excelist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'excel';
    return result;
  };
  // 匹配 word
  var wordlist = ['doc', 'docx'];
  result = wordlist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'word';
    return result;
  };
  // 匹配 pdf
  var pdflist = ['pdf'];
  result = pdflist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'pdf';
    return result;
  };
  // 匹配 ppt
  var pptlist = ['ppt','pptx'];
  result = pptlist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'ppt';
    return result;
  };
  // 匹配 视频
  var videolist = ['mp4', 'm2v', 'mkv','wmv','m3u8'];
  result = videolist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'video';
    return result;
  };
  // 匹配 音频
  var radiolist = ['mp3', 'wav', 'wmv'];
  result = radiolist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'radio';
    return result;
  }
  // 其他 文件类型
  result = 'other';
  return result;
}

/**
 * 相应学校根据年度不显示内容
 * schoolList 数组类型 例如['localhost','hbafajj']
 * gradeList 不需要显示的年度 默认[2020,2021,2022]
 */
export function gradeNotShow(schoolList,gradeList){
    if(!this.$strExistHostnameOnce(schoolList)){
        return true;
    }else{
        if(this.$isEmpty(gradeList)){
            gradeList = [2020,2021,2022];
        }
        const studentInfo = JSON.parse(sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag())); //获取学生信息
        if(studentInfo != null){
            const grade = studentInfo.grade || '2020';
            for(let i = 0;i<gradeList.length;i++){
                if(grade == gradeList[i]){
                    return false;
                }
            }
            return true;
        }else{
            return false;
        }
    }
}

/**
 * 根据获取到的专科还是本科显示名称：专科：实习，本科：论文
 */
export function getShowName(){
    const studentInfo = JSON.parse(sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag())); //获取学生信息
    if(studentInfo != null){
        return studentInfo.cultivationLevelEducation == '专科'?'实习':studentInfo.cultivationLevelEducation == '本科'?'论文':'论文';
    }else{
        return "论文";
    }
}



// WEBPACK FOOTER //
// ./src/common/ulit.js